import React from 'react';

import cx from 'classnames';

import Head from 'components/shared/FileDropZone/Description/Head';
import Center from 'components/shared/Typography/Center';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import { ILightDescProps } from './types';

const LightDesc = ({
  error,
  placeholder,
  headComponent,
  isFilesEmpty,
  className,
  placeholderClassName,
  placeholderIcon,
}: ILightDescProps) => {
  return (
    <>
      <Head error={error} headComponent={headComponent} />
      {isFilesEmpty && (
        <div className={cx(s['dropper-light'], className, 'custom-documents-placeholder-container')}>
          <Center>
            <Text accent type="gray">
              {!!error && (
                <div className={cx(s.error, 'custom-documents-placeholder-error')}>
                  <div>{error}</div>
                  <div>&nbsp;</div>
                </div>
              )}
              {!error && (
                <>
                  {placeholderIcon && (
                    <div className={cx(s.icon, 'custom-documents-placeholder-icon')}>{placeholderIcon()}</div>
                  )}
                  <div className={cx(s.placeholder, placeholderClassName, 'custom-documents-placeholder')}>
                    {placeholder}
                  </div>
                </>
              )}
            </Text>
          </Center>
        </div>
      )}
    </>
  );
};

export default LightDesc;
